var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTrip(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 86,
    viewBox: "0 0 90 86",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M64.9561 59.3117C59.9015 54.4823 53.0464 51.7692 45.8985 51.7692C38.7506 51.7692 31.8954 54.4823 26.8408 59.3117",
    stroke: "#FFF7D7",
    strokeOpacity: 0.71,
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M66.5623 14.8548C61.6098 12.1226 55.7244 11.3822 50.2007 12.7964C44.677 14.2106 39.9674 17.6637 37.1079 22.3959L74.4542 43C77.3134 38.2677 78.0882 32.6439 76.6082 27.3656C75.1282 22.0874 71.5146 17.5871 66.5623 14.8548Z",
    stroke: "#FFF7D7",
    strokeOpacity: 0.71,
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M62.0054 36.132C67.9638 26.2763 70.0015 16.7503 66.5623 14.8547C63.123 12.9592 55.5115 19.4083 49.5566 29.2639",
    stroke: "#FFF7D7",
    strokeOpacity: 0.71,
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M55.7812 32.6979L45 50.5411",
    stroke: "#FFF7D7",
    strokeOpacity: 0.71,
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6562 67.8967C13.775 67.3652 15.0012 67.0723 16.25 67.0382C17.6498 67.0102 19.0356 67.3082 20.2878 67.9065C21.5401 68.5048 22.6211 69.3854 23.4375 70.4722C24.2539 71.5591 25.3349 72.4397 26.5872 73.0379C27.8394 73.6362 29.2252 73.9343 30.625 73.9062C32.0248 73.9343 33.4106 73.6362 34.6629 73.0379C35.9151 72.4397 36.9961 71.5591 37.8125 70.4722C38.6289 69.3854 39.7099 68.5048 40.9621 67.9065C42.2144 67.3082 43.6002 67.0102 45 67.0382C46.3998 67.0102 47.7856 67.3082 49.0379 67.9065C50.2901 68.5048 51.3711 69.3854 52.1875 70.4722C53.0039 71.5591 54.0849 72.4397 55.3371 73.0379C56.5894 73.6362 57.9752 73.9343 59.375 73.9062C60.7748 73.9343 62.1606 73.6362 63.4128 73.0379C64.6651 72.4397 65.7461 71.5591 66.5625 70.4722C67.3789 69.3854 68.4599 68.5048 69.7122 67.9065C70.9644 67.3082 72.3502 67.0102 73.75 67.0382C74.9988 67.0723 76.225 67.3652 77.3438 67.8967",
    stroke: "#FFF7D7",
    strokeOpacity: 0.71,
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrip);
export default __webpack_public_path__ + "static/media/trip.c83c9eb56b1d532a8de8f51680bc6362.svg";
export { ForwardRef as ReactComponent };